// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"menuViewer_modalWrapper__QE2u4"};